import React, {useEffect, useState} from "react" ;

import {ErrorBoundary} from "react-error-boundary";
import VSFallbackComponent from "root/FallbackComponent";

import SpinnerDiv from "ui/SpinnerDiv";
import TablePhonics from "root/Tables/TablePhonics";
import useModalAlternateProviders from "root/Modals/ModalAlternateProviders/useModalAlternateProviders";

import {getChildAltProviders} from "root/DataFunctions/AltProviderDataFns";
import {ModalAlternateProviderModes} from "root/Modals/ModalAlternateProviders/ModalAlternateProviders";
import {useChildContext} from "root/Contexts/ChildContext";
import TableAltProviders from "root/Tables/TableAltProviders";

const AltProvidersSection = ({readOnly, hasLegacy, hideLegacy}) =>
{
    const [ data, setData ] = useState( { isLoading: true, data: []}) ;

    const { child, isLoading } = useChildContext() ;

    const [ renderModal, showAltProviderModal ] = useModalAlternateProviders();

    useEffect(() => {
        if ( isLoading === false )
        {
            getData() ;
        }
    }, [isLoading] ) ;

    const getData = ( mode ) =>
    {
        getChildAltProviders(child.child_id, [], (response) =>
        {
            setData ( { isLoading: false, data: response.data }) ;
        })
    }

    const onClickAdd = ( transferData ) =>
    {
        showAltProviderModal ( {child_id:  child.child_id, mode: ModalAlternateProviderModes.CREATE, transferData: transferData } ).then((results) =>
        {
            getData();

            hideLegacy() ;
        }) ;
    }

    const clickHandler = ({ cap_id, mode}) =>
    {
        showAltProviderModal ( {cap_id, child_id: child.child_id, mode} ).then((results) =>
        {
            getData();
        }) ;
    }

    const addRow = () =>
    {
        return (
            <div className='button-row'>
                <button className='btn btn-primary' type='button' onClick={() => onClickAdd( transferData )}>Add new Alternative Provider</button>
            </div>
        )
    }

    const firstTime = data.isLoading === false && data.data.length === 0 && hasLegacy ;

    const transferData = firstTime ? {
        date_from : child.dmy_alternate_provision_start_date,
        agreement_date : child.dmy_alternate_provision_agreement_date,
        number_of_hours: child.alternate_provision_hours,
        ap_reason_id: +(child.ap_reason_id),
        details: child.alternate_provision_reason,
        days: child.alternate_provision_notes,
    } : null ;

    return (
        <ErrorBoundary  FallbackComponent={VSFallbackComponent}>
            { data.isLoading === false && <TableAltProviders readOnly={readOnly} data={data.data} loading={data.isLoading} clickHandler={clickHandler} allowDelete={true}/> }
            { ( data.isLoading === false && !readOnly ) && addRow() }
            { data.isLoading === true && <SpinnerDiv />}
            {renderModal()}
        </ErrorBoundary>
    )
}

export default AltProvidersSection ;